import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ClockIcon } from '@heroicons/react/outline';
import LanguageSwitcher from '../common/LanguageSwitcher';

// Shown when a saved draft exists, in place of silently dropping the visitor
// into a half-filled form. Two people can share a browser, and a draft can be
// months old, so whose answers are on screen has to be a choice rather than a
// surprise. Purely presentational: it owns no state and never touches storage.
const ApplicationResume = ({ onContinue, onStartFresh, savedStep, totalSteps }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Same placement as the intro screen: someone who cannot read English
            needs to find this before they read anything else. */}
        <div className="flex justify-end mb-4">
          <LanguageSwitcher />
        </div>

        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8 text-center"
        >
          <ClockIcon className="h-12 w-12 text-primary-600 mx-auto mb-4" aria-hidden="true" />
          <h1 className="text-3xl font-display font-bold text-gray-900">{t('resume.title')}</h1>
          <p className="mt-2 text-gray-600">{t('resume.body')}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          className="bg-white rounded-lg shadow-sm p-6"
        >
          <p className="text-gray-800 font-medium mb-6">
            {t('resume.progress', { step: savedStep, total: totalSteps })}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-end">
            <button
              type="button"
              onClick={onContinue}
              className="btn btn-primary"
            >
              {t('resume.continue')}
            </button>
            <button
              type="button"
              onClick={onStartFresh}
              aria-describedby="startFresh-hint"
              className="btn btn-secondary"
            >
              {t('resume.startFresh')}
            </button>
          </div>

          <p id="startFresh-hint" className="mt-4 text-xs text-gray-500">
            {t('resume.startFreshHint')}
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default ApplicationResume;
